import { create } from 'zustand'
import { persist } from 'zustand/middleware'
import type { ContextoCompartilhado } from '../types'

interface ContextoState {
  /** Contas compartilhadas marcadas para entrar na leitura. */
  selecionados: ContextoCompartilhado[]
  /** A própria conta entra na soma? */
  incluirPropria: boolean
  /** Conta que recebe o que for criado ou editado. null = a própria. */
  principalId: string | null

  alternarPropria: () => void
  alternarConta: (contexto: ContextoCompartilhado) => void
  definirPrincipal: (id: string | null) => void
  somenteMinhaConta: () => void
  /** Remove contas que deixaram de ser compartilhadas. */
  sincronizar: (disponiveis: ContextoCompartilhado[]) => void
}

export const useContextoStore = create<ContextoState>()(
  persist(
    (set, get) => ({
      selecionados: [],
      incluirPropria: true,
      principalId: null,

      alternarPropria: () => {
        const { incluirPropria, selecionados, principalId } = get()
        // Nunca deixa a seleção vazia.
        if (incluirPropria && selecionados.length === 0) return
        set({
          incluirPropria: !incluirPropria,
          principalId: incluirPropria && principalId === null ? selecionados[0]?.ownerUserId ?? null : principalId,
        })
      },

      alternarConta: (contexto) => {
        const { selecionados, incluirPropria, principalId } = get()
        const jaEstava = selecionados.some((c) => c.ownerUserId === contexto.ownerUserId)

        if (jaEstava) {
          const restantes = selecionados.filter((c) => c.ownerUserId !== contexto.ownerUserId)
          if (restantes.length === 0 && !incluirPropria) return
          set({
            selecionados: restantes,
            principalId: principalId === contexto.ownerUserId
              ? (incluirPropria ? null : restantes[0]?.ownerUserId ?? null)
              : principalId,
          })
          return
        }

        set({ selecionados: [...selecionados, contexto] })
      },

      definirPrincipal: (id) => set({ principalId: id }),

      somenteMinhaConta: () => set({ selecionados: [], incluirPropria: true, principalId: null }),

      sincronizar: (disponiveis) => {
        const { selecionados, principalId } = get()
        const ids = new Set(disponiveis.map((c) => c.ownerUserId))
        const restantes = selecionados.filter((c) => ids.has(c.ownerUserId))
        if (restantes.length === selecionados.length) return

        set({
          selecionados: restantes,
          principalId: principalId && ids.has(principalId) ? principalId : null,
          incluirPropria: restantes.length === 0 ? true : get().incluirPropria,
        })
      },
    }),
    { name: 'walleon-contexto' },
  ),
)
